// extracted by mini-css-extract-plugin
export default {"LoadError":"bfg_a bhs_qs bhs_a bhs_w bhs_j bhs_q","LoadError__icon":"bfg_b bhs_vl bhs_fm bhs_sw","LoadError__message":"bfg_c bhs_fm bhs_tr"};